const translations = {
    requiredError: 'Tax code is required'
};

export default translations;
